import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PhotoPreviewData } from 'src/app/interface/photo-preview.interface';

@Component({
  selector: 'app-photo-preview',
  templateUrl: './photo-preview.component.html',
  styleUrls: ['./photo-preview.component.scss']
})
export class PhotoPreviewComponent {
  constructor(
    public dialogRef: MatDialogRef<PhotoPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PhotoPreviewData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
